import React, { useState, useCallback, Suspense, lazy, useEffect } from 'react';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { BsBarChart, BsSearch } from 'react-icons/bs';
import { FaPlus, FaMinus } from 'react-icons/fa';
import { LuTicket } from 'react-icons/lu';
import { BsTrophy } from 'react-icons/bs';
import { IoRemoveOutline } from 'react-icons/io5';
import styles from './style.module.scss';

const ModalVerBoloes = lazy(() => import('../ModalVerBoloes'));

const CardBoloes = ({ bolao, modalSetConcursoAndState, handleAddToCart, setApostaId, setModalVerApostas, quantidadeApostas, boloesArray, showModal, isLoading, setIsLoading, subBolaoData, setSubBolaoData, isModalVisible, setIsModalVisible }) => {
  const [quantidades, setQuantidades] = useState({});

  const closeModal = useCallback(() => setIsModalVisible(false), [setIsModalVisible]);

  const hexToRGBA = useCallback((hex, opacity) => {
    if (!hex) return '';
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((hexChar) => hexChar + hexChar)
        .join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }, []);

  const formatPrize = useCallback((value) => {
    console.log('value', value)
    if (!value) return { number: '0', word: '' };
    let numberPart;
    let wordPart = '';

    if (value >= 1000000) {
      numberPart = (value / 1000000).toFixed(1);
      wordPart = parseFloat(numberPart) > 1 ? 'Milhões' : 'Milhão';
    } else if (value >= 1000) {
      numberPart = (value / 1000).toFixed(1);
      numberPart = numberPart.endsWith('.0') ? numberPart.slice(0, -2) : Part;
      wordPart = 'Mil';
    } else {
      numberPart = value.toString();
    }
    return { numberPart, word: wordPart };
  }, []);

  const formatarComoMoeda = useCallback((valor) => {
    if (!valor) return 'R$ 0,00';
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  }, []);

  const updateQuantidade = useCallback((id, delta) => {
    setQuantidades((prev) => ({
      ...prev,
      [id]: Math.max(1, (prev[id] || 1) + delta),
    }));
  }, []);

  const handleQuantityChange = useCallback((id, value) => {
    if (value >= 1) {
      setQuantidades((prev) => ({ ...prev, [id]: value }));
    }
  }, []);

  // Filter and sort boloes
  const filteredBoloesArray = boloesArray.filter((b) => b.id === bolao?.id);
  const sortedBoloesArray = filteredBoloesArray
    .flatMap((b) => b.boloes || [])
    .sort((a, b) => {
      if (a.cotas_restantes === 0 && b.cotas_restantes > 0) return 1;
      if (a.cotas_restantes > 0 && b.cotas_restantes === 0) return -1;
      if (a.cotas_restantes === 1 && b.cotas_restantes > 1) return 1;
      if (a.cotas_restantes > 1 && b.cotas_restantes === 1) return -1;
      return b.valor_cota - a.valor_cota;
    });

  const handleVerJogos = (subbolao) => {
    modalSetConcursoAndState(subbolao);
  };

  if (!bolao) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingSpinner}></div>
        <p>Carregando bolões...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.boloesGrid}>
        {sortedBoloesArray.map((subbolao, index) => (
          <div
            key={subbolao.id}
            className={`${styles.card} ${subbolao.cotas_restantes === 0 ? styles.soldOut : ''}`}
            style={{
              '--card-color': bolao.cor,
              '--card-bg': hexToRGBA(bolao.cor, 0.1),
              '--card-border': hexToRGBA(bolao.cor, 0.2),
            }}
          >
            {/* Card Header */}
            <div className={styles.cardHeader} style={{ backgroundColor: bolao.cor }}>
              <h3 className={styles.cardTitle}>
                Grupo
                <br />
                {subbolao.grupo}
              </h3>
              {subbolao.cotas_restantes === 0 && (
                <div className={styles.soldOutBadge}>
                  <span>Esgotado</span>
                </div>
              )}
            </div>

            {/* Card Body */}
            <div className={styles.cardBody}>
              {/* Prize Section */}
              <div className={styles.cardPrize} style={{ backgroundColor: hexToRGBA(bolao.cor, 0.2) }}>
                <p className={styles.cardSubtitle} style={{ color: bolao.cor }}>
                  Concurso: {bolao.concurso}
                </p>
                <div className={styles.cotasInfo}>
                  <LuTicket style={{ color: bolao.cor }} />
                  <span style={{ color: bolao.cor }}>
                    {subbolao.cotas_restantes} de {subbolao.cotas} cotas
                  </span>
                </div>
              </div>

              {/* Prize Amount */}
              <div className={styles.cardCost} style={{ backgroundColor: hexToRGBA(bolao.cor, 0.2) }}>
                <BsTrophy className={styles.cardIcon} style={{ backgroundColor: bolao.cor, padding: 5 }} />
                <span className={styles.prizeAmount} style={{ color: bolao.cor }}>
                  R$ {formatPrize(bolao.premiacao)?.numberPart} {formatPrize(bolao.premiacao)?.word}
                </span>
              </div>

              {/* Cota Value */}
              <div className={styles.cotaValor}>
                <span className={styles.cotaPrice}>{formatarComoMoeda(subbolao.valor_cota)}</span>
                <span className={styles.cotaLabel}>por cota</span>
              </div>

              {/* Quantity Control */}
              <div className={styles.quantitySection}>
                <label className={styles.quantityLabel}>Quantidade:</label>
                <div className={styles.quantityControl} style={{ borderColor: bolao.cor }}>
                  <button className={styles.quantityButton} disabled={quantidades[subbolao.id] === 1} onClick={() => updateQuantidade(subbolao.id, -1)} style={{ color: bolao.cor }}>
                    <FaMinus />
                  </button>

                  <div className={styles.quantityDisplay}>
                    <input type='number' min={1} max={subbolao.cotas_restantes} value={quantidades[subbolao.id] || 1} onChange={(e) => handleQuantityChange(subbolao.id, parseInt(e.target.value) || 1)} className={styles.quantityInput} />
                  </div>

                  <button className={styles.quantityButton} disabled={quantidades[subbolao.id] >= subbolao.cotas_restantes} onClick={() => updateQuantidade(subbolao.id, 1)} style={{ color: bolao.cor }}>
                    <FaPlus />
                  </button>
                </div>
              </div>

              {/* Add to Cart Button */}
              <button
                className={`${styles.addToCartButton} ${subbolao.cotas_restantes === 0 ? styles.disabled : ''}`}
                disabled={subbolao.cotas_restantes === 0}
                onClick={() => {
                  if (subbolao.cotas_restantes > 0) {
                    handleAddToCart(bolao.nome, subbolao, quantidades[subbolao.id] || 1, bolao.data_sorteio, bolao.nome);

                    // GTM Event
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: 'purchase',
                      product: {
                        name: bolao.nome,
                        subBolao: subbolao,
                        quantidade: quantidades[subbolao.id] || 1,
                        dataSorteio: bolao.data_sorteio,
                        nome: bolao.nome,
                      },
                    });
                  }
                }}
                style={{ backgroundColor: subbolao.cotas_restantes === 0 ? '#ccc' : '#feac24' }}
              >
                <MdOutlineShoppingCart />
                {subbolao.cotas_restantes === 0 ? 'Esgotado' : 'Adicionar ao carrinho'}
              </button>
            </div>

            {/* Card Footer */}
            <div className={styles.cardFooter}>
              <button className={styles.actionButton} onClick={() => handleVerJogos(subbolao)} style={{ backgroundColor: bolao.cor }}>
                <BsSearch />
                Ver jogos
              </button>

              <button className={styles.actionButton} onClick={() => showModal(subbolao)} style={{ backgroundColor: bolao.cor }}>
                <BsBarChart />
                Estratégia
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      <Suspense fallback={<div className={styles.modalLoading}>Carregando...</div>}>
        {isModalVisible && (
          <ModalVerBoloes
            nome={bolao.nome}
            color={bolao.cor}
            regra={subBolaoData.regra}
            concurso={bolao.concurso}
            dataSorteio={bolao.data_sorteio}
            valor={`R$ ${formatPrize(bolao.premiacao)?.numberPart} ${formatPrize(bolao.premiacao)?.word}`}
            isModalVisible={isModalVisible}
            closeModal={closeModal}
            cotas={subBolaoData.cotas}
            handleAddToCart={handleAddToCart}
            subBolaoCart={subBolaoData.subBolaoCart}
            quantidadeApostas={quantidadeApostas}
            modalSetConcursoAndState={modalSetConcursoAndState}
            setModalVerApostas={setModalVerApostas}
          />
        )}
      </Suspense>
    </div>
  );
};

export default React.memo(CardBoloes);
